/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-vendor-depot': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M7.13.017l.083.03 6.5 3.06a.5.5 0 0 1 .28.37L14 3.56V13.5a.5.5 0 0 1-.992.09L13 13.5V3.876L7 1.052 1 3.875V13.5a.5.5 0 0 1-.41.492L.5 14a.5.5 0 0 1-.492-.41L0 13.5V3.559a.5.5 0 0 1 .216-.412l.071-.04 6.5-3.06a.5.5 0 0 1 .343-.03zM7 5.47c.648 0 1.182.493 1.246 1.125l.007.128-.001.253h2.513a.5.5 0 0 1 .492.41l.008.09V13.5a.5.5 0 0 1-.41.492l-.09.008H7.763a.51.51 0 0 1-.01 0l-.011-.001L3.235 14a.5.5 0 0 1-.492-.41l-.008-.09V8.981a.5.5 0 0 1 .41-.492l.09-.008H4.24V6.722c0-.649.493-1.182 1.125-1.246l.128-.007H7zm.252 4.012H3.734v3.518h3.518V9.481zm1.001-.5l-.001.011v4.007h2.013V7.975H8.252l.001.995a.51.51 0 0 1 0 .011zM7 6.47H5.493c-.12 0-.22.083-.246.195l-.007.058v1.759h2.012V6.722c0-.12-.083-.22-.194-.246L7 6.469z" _fill="#54021A" fill-rule="evenodd"/>'
  }
})
